package com.essntl.features.area.data.supabase

import com.essntl.core.utils.utils.capitalise
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.country.data.supabase.CountryDto
import io.github.jan.supabase.postgrest.query.Columns
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AreaDto(
    val id: String,
    val name: String,
    @SerialName("created_at")
    val createdAt: String,
    @SerialName("country_id_data")
    val countryDto: CountryDto? = null,
) {
    fun toModel() =
        AreaModel(
            id = id,
            name = name.lowercase().capitalise(),
            createdAt = createdAt,
            countryModel = countryDto?.toModel(),
        )

    companion object {
        private const val COLUMNS_VALUE = "*, country_id_data:country_id(*)"
        fun getColumns() = Columns.raw(COLUMNS_VALUE)
    }
}
